import styled from 'styled-components';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import { CALYPSO } from 'HubStyleTokens/colors';
import { Fragment } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TileWithLeftBorder = styled(UITile).withConfig({
  displayName: "ConditionalPropertiesPanelDependentSection__TileWithLeftBorder",
  componentId: "sc-6fb6yv-0"
})(["border-left:solid 5px ", ";"], CALYPSO);
const StyledDivWithBottomMargin = styled.div.withConfig({
  displayName: "ConditionalPropertiesPanelDependentSection__StyledDivWithBottomMargin",
  componentId: "sc-6fb6yv-1"
})(["&:not(:last-of-type){margin-bottom:12px !important;}"]);
const renderDependents = (dependents, path, passthroughProps, renderInput) => {
  return /*#__PURE__*/_jsx(_Fragment, {
    children: dependents.map(dependent => /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(StyledDivWithBottomMargin, {
        "data-test-id": `${path}-${dependent.property.name}`,
        children: renderInput ? renderInput(dependent) : dependent.render(passthroughProps)
      }), renderDependents(dependent.dependents, `${path}-${dependent.property.name}`, passthroughProps, renderInput)]
    }, `${path}-${dependent.property.name}`))
  });
};
function ConditionalPropertiesPanelDependentSection({
  input,
  passthroughProps,
  renderInput
}) {
  return /*#__PURE__*/_jsx(TileWithLeftBorder, {
    compact: true,
    className: "m-top-4 m-bottom-2",
    "data-test-id": `${input.property.name}-dependents`,
    children: /*#__PURE__*/_jsx(UITileSection, {
      className: "p-top-2",
      children: renderDependents(input.dependents, input.property.name, passthroughProps, renderInput)
    })
  });
}
export default ConditionalPropertiesPanelDependentSection;